import { render, staticRenderFns } from "./InvestmentTransactionVersionCardContent.vue?vue&type=template&id=5a7061c5&"
import script from "./InvestmentTransactionVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./InvestmentTransactionVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports